import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ──────────────────────────────────────────────────────────────────
// Replace this with your real Google OAuth Client ID.
// Create one at: https://console.cloud.google.com/apis/credentials
//   → Create Credentials → OAuth 2.0 Client ID → Web application
//   → Add http://localhost:3000 (dev) and your production domain
//     to "Authorised JavaScript origins"
// ──────────────────────────────────────────────────────────────────
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "YOUR_GOOGLE_CLIENT_ID_HERE";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(reg => {
      // Ask SW to register periodic background sync (Chrome Android only, ignored elsewhere)
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'REGISTER_PERIODIC_SYNC' });
      } else {
        reg.addEventListener('updatefound', () => {
          reg.installing?.addEventListener('statechange', () => {
            if (reg.active) reg.active.postMessage({ type: 'REGISTER_PERIODIC_SYNC' });
          });
        });
      }
      // Listen for BG_SYNC from the SW — trigger the app's poll cycle
      navigator.serviceWorker.addEventListener('message', e => {
        if (e.data?.type === 'BG_SYNC') {
          window.dispatchEvent(new CustomEvent('sl-bg-sync'));
        }
      });
    }).catch(() => {});
  });
}
